import { TableRow } from "@material-ui/core";
import React from "react";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import Typography from '@mui/material/Typography';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const avgData = this.props.topData;

        return (
            <div>
                <h3><center><u>Best Plucker Performance Analysis Report</u></center></h3>
                <div className="row pl-2 pb-2 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                </div>
                <div className="row pl-2 pb-2 pt-2">
                    <div className="col"><b>From: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To: </b> {searchData.toDate}</div>
                    <div className="col"></div>
                </div>
                <div>
                    <TableContainer component={Paper}>
                        {data.map((row, i) => (
                            <>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Reg No</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>No of Days</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity (Kg)</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Per Day Avg (%)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.groupedData.map((rows, i) => (
                                            <TableRow key={i} >
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.division}</TableCell>
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.employeeName}</TableCell>
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.employeeID}</TableCell>
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {rows.days}</TableCell>
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {parseFloat(rows.qty).toFixed(2)}</TableCell>
                                                <TableCell component="th" style={{ backgroundColor: (row.groupedData.length - 1 === i) ? '#a5d6a7' : null }} scope="row" align="center"> {(rows.perDayAverage).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <br />
                                    </TableBody>
                                </Table>
                            </>
                        ))
                        }
                    </TableContainer>
                    <br /><br />
                    <Typography variant="body1" gutterBottom sx={{ color: "#2e7d32", fontWeight: "bold", textAlign: "center" }}>
                        Overall Plantation - Top Pluckers
                    </Typography>
                    <TableContainer component={Paper}>
                        <>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#a5d6a7' }}>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Reg No</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>No of Days</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity</TableCell>
                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Per Day Avg</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {avgData.map((rows, i) => (
                                        <TableRow key={i} style={{ backgroundColor: '#a5d6a7' }} >
                                            <TableCell component="th" scope="row" align="center"> {rows.division}</TableCell>
                                            <TableCell component="th" scope="row" align="center"> {rows.employeeName}</TableCell>
                                            <TableCell component="th" scope="row" align="center"> {rows.employeeID}</TableCell>
                                            <TableCell component="th" scope="row" align="center"> {rows.days}</TableCell>
                                            <TableCell component="th" scope="row" align="center"> {parseFloat(rows.qty).toFixed(2)}</TableCell>
                                            <TableCell component="th" scope="row" align="center" > {parseFloat(rows.perDayAverage).toFixed(2)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </>
                    </TableContainer>
                </div>

            </div>
        );
    }
}